var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rk-progress"},[_c('div',{staticClass:"rk-progress-inner",style:(("width:" + _vm.precent + "%;background-color: " + _vm.color + ";"))})])}
var staticRenderFns = []

export { render, staticRenderFns }